import commonUtils from "@/js/workspace/common_util.js";
import upgradeItemUtils from '@/js/workspace/upgrade_item.js';
import requestUtils from "../request_util";
import getCurrencyUtils from '@/js/workspace/get_currency.js';
export default {
            //封装post请求的信息
            packageDataJson (isPreview,subId) {
                var dataJson = {};
                var AlignmentSettings = {};
                AlignmentSettings.AlignToCurrentInterval = true;//立即向客户收取更新费用
                AlignmentSettings.ExtendInterval = true;//按新产品周期算差价
                AlignmentSettings.GetCustomerPricePreviewOnly = isPreview;
                dataJson.AlignmentSettings = AlignmentSettings;
                dataJson.GenerateMail = true;
                dataJson.ProductId = 236257;
                dataJson.Quantity = 1;
                dataJson.RunningNumber = 1;
                dataJson.SubscriptionId = subId;
                dataJson.ForcePriceRecalculation = false;
                dataJson.UpdateAction = "Update";
                return dataJson;
              },
                //封装post请求的信息
                packageHalloweenDataJson (isPreview,subId) {
                var dataJson = {};
                var AlignmentSettings = {};
                AlignmentSettings.AlignToCurrentInterval = true;//立即向客户收取更新费用
                AlignmentSettings.ExtendInterval = true;//按新产品周期算差价
                AlignmentSettings.GetCustomerPricePreviewOnly = isPreview;
                dataJson.AlignmentSettings = AlignmentSettings;
                dataJson.GenerateMail = true;
                dataJson.ProductId = 236257;
                dataJson.Quantity = 1;
                dataJson.RunningNumber = 1;
                dataJson.SubscriptionId = subId;
                dataJson.ForcePriceRecalculation = false;
                dataJson.UpdateAction = "Update";
                dataJson.CouponCode = "GMQ-H9V-649";
                return dataJson;
              },
              getItemPreview (source,callback) {
                var user = commonUtils.getUser();
                var subId = user.subscrId;
                if(user.subscrId.indexOf('-')>0){
                  subId = user.subscrId.slice(0, user.subscrId.indexOf('-'));
              }
                var dataJson;
                if(!source){
                dataJson = upgradeItemUtils.packageDataJson(true,subId);
                }else{
                dataJson = upgradeItemUtils.packageHalloweenDataJson(true,subId);    
                }
                var self = this;
                requestUtils.doSubinquiryPostRequest('update_subscription_item', dataJson).then(res => {
                  //如果请求成功设置显示信息
                  if (res.ResultMessage == 'OK') {
                    var currency = getCurrencyUtils.getCurrencyByCurrencyId(res.PriceCurrencyId);
                    if(!source){
                    if(currency == "€" || currency=='円'){
                        if(currency == "€"){
                            res.AlignmentCustomerNetPrice = self.formatNum(res.AlignmentCustomerNetPrice);
                            res.NextBillingCustomerNetPrice = self.formatNum(res.NextBillingCustomerNetPrice);
                            res.NextBillingCustomerGrossPrice = self.formatNum(res.NextBillingCustomerGrossPrice);
                        }
                        localStorage.setItem(user.id+"newPayMoney",res.AlignmentCustomerNetPrice+currency);
                        localStorage.setItem(user.id+"oldPayMoney",res.NextBillingCustomerNetPrice+currency);
                        localStorage.setItem(user.id+"oldGross",res.NextBillingCustomerGrossPrice+currency);
                    }else{
                        localStorage.setItem(user.id+"newPayMoney",currency+res.AlignmentCustomerNetPrice); 
                        localStorage.setItem(user.id+"oldPayMoney",currency+res.NextBillingCustomerNetPrice);
                        localStorage.setItem(user.id+"oldGross",currency+res.NextBillingCustomerGrossPrice);
                    }
                  }else{
                    if(currency == "€" || currency=='円'){
                        if(currency == "€"){
                            res.AlignmentCustomerNetPrice = self.formatNum(res.AlignmentCustomerNetPrice);
                            res.NextBillingCustomerNetPrice = self.formatNum(res.NextBillingCustomerNetPrice);
                        }
                        localStorage.setItem(user.id+"hallonewPayMoney",res.AlignmentCustomerNetPrice+currency);
                        localStorage.setItem(user.id+"halloldPayMoney",res.NextBillingCustomerNetPrice+currency);
                    }else{
                        localStorage.setItem(user.id+"hallonewPayMoney",currency+res.AlignmentCustomerNetPrice);
                        localStorage.setItem(user.id+"halloldPayMoney",currency+res.NextBillingCustomerNetPrice); 
                    }
                  }
                  }
                  callback(res);
                });
              },
              formatNum(n,is_int=false) {
                //转化成字符串
                var str = n.toString();
                //若是整数自动补全小数位
                if (-1 == str.indexOf(".")) {
                    str = str + ".00"
                }
                //全部替换
                if (-1 != str.indexOf(",")) {
                    str = str.replace(new RegExp(',', "g"), "")
                }
                var intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
                if(is_int){
                    return intSum;
                }
                var dot = str.substring(str.length, str.indexOf(".")+1)//取到小数部分搜索
                var ret = intSum +","+ dot;
                return ret;
            }
}


// WEBPACK FOOTER //
// ./src/js/workspace/upgrade_item.js